window.addEventListener('DOMContentLoaded', (event) => {
    document.getElementById("l-zwart").disabled = false;
    document.getElementById("l-wit").disabled = false;
    document.getElementById("l-grijs").disabled = false;
});